<template>
  <div class="policy">
    <common-layout>
      <!-- <div slot="header">
        <div class="policy_tabs">
          <span
            v-for="btn in tabs"
            :key="btn.id"
            @click="handleClick(btn.id)"
            :class="{'active_t':activeName== btn.id}"
          >{{btn.name}}</span>
        </div>
      </div> -->
      <div slot="container">
        <div class="policy-search" v-show="activeName == 2">
          <el-button
            type="success"
            icon="el-icon-plus"
            @click="add"
            style="background: #623AA2;border: none;"
          >新增</el-button>
          <el-button type="danger" icon="el-icon-delete" @click="deleteAll">批量删除</el-button>
          <el-input
            placeholder="请输入标题内容"
            v-model="searchValue"
            class="input-with-select"
            @keyup.enter.native="search"
            clearable
            @clear="search"
          >
            <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
          </el-input>
        </div>
        <div id="table">
          <!--动态绑定长宽-->
          <el-table
            ref="multipleTable"
            :data="tableData"
            style="width: 100%"
            type="index"
            @selection-change="tabSelect"
            :header-cell-style="headerStyle"
          >
            <el-table-column v-show="activeName == 2" type="selection"></el-table-column>
            <el-table-column type="index" width="150" label="序号" align="center">
              <template slot-scope="scope">
                <span>{{ scope.$index + (currentPage - 1) * per_page + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="key" label="关键字"></el-table-column>
            <!-- <el-table-column prop="category_second" label="类型" align="center" v-if="show" width="100">
							<template slot-scope="scope">
								<span>
									{{ scope.row.category_second==1?'科技口':scope.row.category_second==2?'工信口':scope.row.category_second==3?'发改口':scope.row.category_second==4?'人社口':'其他口'}}
								</span>
							</template>
            </el-table-column>-->
            <el-table-column prop="number" label="热度" align="center"></el-table-column>
         
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <!-- <el-button-group> -->
        
                <el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
         
                <!-- </el-button-group> -->
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-size="per_page"
          layout="total, prev, pager, next, jumper"
          :total="total"
          style="text-align:left;margin:20px 0"
        ></el-pagination>
      </div>
    </common-layout>
    <!--    <el-tabs v-model="activeName">
      <el-tab-pane label="国家级政策" name="1"></el-tab-pane>
      <el-tab-pane label="省级政策" name="2"></el-tab-pane>
      <el-tab-pane label="市级政策" name="3"></el-tab-pane>
      <el-tab-pane label="政策解读" name="4"></el-tab-pane>
    </el-tabs>-->

    <el-dialog :title="Title" width="600px" :visible.sync="dialogFormVisible" :close-on-click-modal="false">
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        label-width="105px"
        :rules="rules"
        class="demo-ruleForm"
      >
        <el-form-item label="关键字" prop="key">
			<el-col :span="22">
				 <el-input v-model="ruleForm.key" clearable></el-input>
			</el-col>
        </el-form-item>

          <el-col :span="15" style="text-align:right">
            <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
            <el-button @click="closeForm('ruleForm')">取消</el-button>
          </el-col>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import editor from "../../components/tinymce-editor/tinymce-editor";
// import editor from "../../../components/yhQuillEditor";
import CommonLayout from "../../components/common-layout.vue";
export default {
  components: {
    editor,
    CommonLayout,
  },
  data() {
    return {
      headerStyle: {
        color: "#623AA2",
        background: "#E5F3FE",
      },
      show: false,
      tabs: [
        {
          id: 2,
          name: "专题关键字",
        },
        {
          id: 1,
          name: "基础关键字",
        },
      ],
      type: "",
      activeName: 2,
      selected: "",
      searchValue: "",
      total: 10,
      per_page: 10,
      currentPage: 1,
      dialogFormVisible: false,
      Title: "",
      tableData: [],
      ruleForm: {
        key: "",
      },
      rules: {
        key: [
          {
            required: true,
            message: "请输入关键词",
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
    // this.getDate("policy?activeName=" + this.activeName);
    // this.getDate("Resource_Key?type=" + this.activeName);
    this.getDate("Resource_Key");
  },
  methods: {
    getDate(url) {
      this.http.get(url).then((res) => {
        if (res.code == 0) {
          this.tableData = res.data.data;
          this.per_page = res.data.per_page;
          this.total = res.data.total;
          this.currentPage = res.data.current_page;
        } else {
          this.$message.error("获取数据失败！！");
        }
      });
    },
    //新增
    add() {
      this.Title = "新建";
      this.dialogFormVisible = true;
      this.ruleForm = {
        key: "",

      };
    },
    //编辑
    handleEdit(val) {
      this.Title = "编辑";
      this.dialogFormVisible = true;
      this.http.get("Resource_Key/" + val.id).then((res) => {
        if (res.code == 0) {
          this.ruleForm = JSON.parse(JSON.stringify(res.data));
        }
      });
    },
    //提交
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let obj = JSON.parse(JSON.stringify(this.ruleForm));
          // obj.type = this.activeName;
          // if (this.activeName == 1) {
          // 	delete obj.category_second;
          // }
          if (!obj.id) {
            this.http.post("Resource_Key", obj).then((res) => {
              if (res.code == 0) {
                this.$message.success("新建成功");
                // this.getDate("Resource_Key?type=" + this.activeName);
                this.getDate("Resource_Key");
                this.dialogFormVisible = false;
                this.$refs[formName].resetFields();
              } else {
                this.$message.error(res.status);
              }
            });
          } else {
            this.http
              .put("Resource_Key/" + this.ruleForm.id, obj)
              .then((res) => {
                if (res.code == 0) {
                  this.$message.success("编辑成功");
                  // this.getDate("Resource_Key?type=" + this.activeName);
                  this.getDate("Resource_Key");
                  this.dialogFormVisible = false;
                  this.$refs[formName].resetFields();
                } else {
                  this.$message.error(res.status);
                }
              });
          }
        } else {
          return false;
        }
      });
    },
    //取消
    closeForm(formName) {
      this.dialogFormVisible = false;
      this.$refs[formName].resetFields();
    },
    //发布
    preview(e) {
      let data = {};
      if (e.is_publish == 1) {
        data.is_publish = 2;
      } else if (e.is_publish == 2) {
        data.is_publish = 1;
      }
      this.http.put("Resource_Key/" + e.id, data).then((res) => {
        if (res.code == 0) {
          if (data.is_publish == 1) {
            this.$message.success("发布成功");
          } else {
            this.$message.success("已取消发布");
          }
          // this.getDate("Resource_Key?type=" + this.activeName);
          this.getDate("Resource_Key");
        } else {
          this.$message.error(res.status);
        }
      });
    },
    //搜索
    search() {
      this.getDate("Resource_Key?&key=" + this.searchValue)
      // this.getDate(
      //   "Resource_Key?type=" +
      //     this.activeName +
      //     "&key=" +
      //     this.searchValue
      // );
    },
    selectType(e) {
      this.getDate(
        "Resource_Key?type=" +
          this.activeName +
          "&key=" +
          this.searchValue
      );
    },
    //删除
    handleDelete(row) {
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.http
            .request("Resource_Key/" + row.id, "", "delete")
            .then((res) => {
              if (res.code == 0) {
                // this.getDate("Resource_Key?type=" + this.activeName);
                this.getDate("Resource_Key");
                this.searchValue = "";
                this.type = "";
                this.$message({
                  type: "success",
                  message: "删除成功",
                });
              } else {
                this.$message({
                  message: "失败！",
                  type: "error",
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //批量删除
    deleteAll() {
      if (this.selected) {
        this.$confirm("确定删除文件吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
        })
          .then(() => {
            this.http
              .request("Resource_Key/" + this.selected, "", "delete")
              .then((response) => {
                if (response.code == 0) {
                  this.$message.success("删除成功！");
                  // this.getDate("Resource_Key?type=" + this.activeName);
                  this.getDate("Resource_Key");
                  this.searchValue = "";
                  this.type = "";
                }
              });
            this.$message({
              type: "success",
              message: "删除成功!",
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      } else {
        this.$message({
          type: "warning",
          message: "请选择删除的文件",
        });
      }
    },
    //富文本
    getQuillData(val) {
      this.ruleForm.content = val;
    },
    //翻页
    handleCurrentChange(val) {
      this.getDate('Resource_Key?key='+this.searchValue +"&page=" +val)
      // this.getDate(
      //   "Resource_Key?type=" +
      //     this.activeName +
      //     "&key=" +
      //     this.searchValue +
      //     "&page=" +
      //     val
      // );
    },
    //选择行数
    tabSelect(sec) {
      let ids = "";
      for (let i of sec) {
        ids += i.id + ",";
      }
      ids = ids.substr(0, ids.length - 1);
      this.selected = ids;
    },
    // 切换tab
    handleClick(val) {
      this.activeName = val;
      this.searchValue = "";
      this.type = "";
      this.getDate("Resource_Key?type=" + this.activeName);
    },
  },
};
</script>

<style lang="scss" scoped>
.policy {
  height: 100%;

  .policy-search {
    width: 100%;
    text-align: left;
    display: flex;
    justify-content: flex-start;

    // margin-top: 20px;
    .el-input {
      width: 400px;
      margin: 0 15px;
    }

    .selectType {
      display: inline-block;
    }
  }

  .policy_tabs {
    width: 300px;
    height: 50px;
    border: 1px solid #ef9f49;
    display: flex;
    border-radius: 50px;
    overflow: hidden;
    cursor: pointer;

    > span {
      display: inline-block;
      width: 150px;
      height: 50px;
      line-height: 50px;
      font-weight: bold;

      &.active_t {
        background: linear-gradient(to bottom right, #fbc434 0%, #f66b4e 100%);
        color: #fff;
      }
    }
  }

  .policey_nav {
    display: flex;
    align-items: center;
    justify-content: space-between;

    li {
      &.active-Tab {
        color: rgba(255, 255, 255, 0.4);

        &:before {
          display: inline-block;
          padding-right: 0.5rem;
          padding-left: 0.5rem;
          color: rgba(255, 255, 255, 0.4);
          content: "/";
        }
      }
    }
  }

  #table {
    margin-top: 20px;
    border: 1px solid #eef1f6;

    /deep/ th {
      // background-color: #eef1f6 !important;
      // color: #000;
    }

    /deep/ td {
    }

    /deep/ .cell {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    p {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .blue {
      color: #47eb0d;
    }

    .red {
      color: red;
    }
  }

  /deep/ .yh-quill-editor {
    .el-upload {
      display: none;
    }

    .ql-toolbar {
      text-align: left;
    }
  }
}
/deep/ .el-dialog__body {
	padding-bottom: 60px;;
}
</style>
